import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
  } from '@mui/material';

  interface ResetMatchScoreAlertProps {
    open: boolean;
    handleClose: () => void;
    title: string;
    message: string;
    buttons: { text: string; color: 'primary' | 'error'; onClick: () => void }[];
  }

  const ResetMatchScoreAlert = ({ open, handleClose, title, message, buttons }: ResetMatchScoreAlertProps) => {
    return (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ sx: { minWidth: 400 } }}
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          {buttons.map((button, index) => (
            <Button
              key={index}
              color={button.color || 'primary'}
              onClick={() => {
                if (button.onClick) {
                  button.onClick();
                }
                handleClose();
              }}
            >
              {button.text}
            </Button>
          ))}
        </DialogActions>
      </Dialog>
    );
  };
  
  export default ResetMatchScoreAlert;